import Temp from './Temp'

export default Temp